export function registrationPaymentLabel(reg: { paymentStatus?: string | null; status?: string | null }): string {
  if (reg.status === 'cancelled') return 'Cancelado';
  if (reg.status === 'expired' || reg.paymentStatus === 'expired') return 'Expirado';
  switch (reg.paymentStatus) {
    case 'paid':
      return 'Pago';
    case 'pending':
      return 'Aguardando pagamento';
    case 'refunded':
      return 'Reembolsado';
    case 'failed':
      return 'Falhou';
    default:
      return 'Aguardando pagamento';
  }
}

export function registrationPaymentChipColor(
  reg: { paymentStatus?: string | null; status?: string | null }
): 'success' | 'warning' | 'default' | 'error' {
  if (reg.status === 'cancelled') return 'error';
  if (reg.status === 'expired' || reg.paymentStatus === 'expired') return 'default';
  switch (reg.paymentStatus) {
    case 'paid':
      return 'success';
    case 'pending':
      return 'warning';
    case 'refunded':
    case 'failed':
      return 'error';
    default:
      return 'default';
  }
}

export function paymentAttemptChipColor(
  status?: string | null
): 'success' | 'warning' | 'default' | 'error' {
  switch (status) {
    case 'paid':
      return 'success';
    case 'pending':
      return 'warning';
    case 'failed':
      return 'error';
    default:
      return 'default';
  }
}

export function paymentAttemptLabel(status?: string | null): string {
  switch (status) {
    case 'paid':
      return 'Pago';
    case 'pending':
      return 'Aguardando pagamento';
    case 'failed':
      return 'Falhou';
    case 'expired':
      return 'Expirada';
    case 'cancelled':
      return 'Cancelada';
    default:
      return status || '—';
  }
}
